import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { ChangeLogTypeEnum } from '../../@store/updates/changelog.model';

@Component({
  selector: 'app-updates-tabs',
  templateUrl: './updates-tabs.component.html',
  styleUrls: ['./updates-tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpdatesTabsComponent {
  readonly changeLogTypeEnum = ChangeLogTypeEnum;

  activeTab = ChangeLogTypeEnum.ViGuide;

  @Input() viGuideUpdatesAmount: number;
  @Input() viCareAndroidUpdatesAmount: number;
  @Input() viCareIOSUpdatesAmount: number;

  @Output() tabChanged = new EventEmitter<ChangeLogTypeEnum>();

  onTabSelect(type: ChangeLogTypeEnum): void {
    this.activeTab = type;
    this.tabChanged.emit(type);
  }
}
